/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { Icon } from '@ss/mtd-react';
import { Form, Tooltip } from '@block/plug';
import { datejs, isEmpty } from '@block/utils';
import { getEduType, handleAdapterData } from '@src/utils/educationUtils';
import { customReport } from '@src/utils/customReport';
import Url from './url';
import { doAction } from '../../utils';
import defaultPhoto from '../../../imgs/formal-example.png';
import './index.scss';
import Supplementary from '../educationInfo/components/Supplementary';
import CertificateUploadGroup from '../educationInfo/components/CertificateUploadGroup';

const mode = 'view';
const tipList = [
  '本人真实照片，白底半身照，面部无遮挡、免冠',
  '2寸（照片长宽比16:11，不低于560*385像素）',
  '大小300K以上，不超过15M，格式为 jpg/png',
];

interface Props {
  hasShowAll: boolean;
}

interface State {
  loading: boolean;
  employeeType: string;
  basicInfo: any;
  personalInfo: any;
  bankInfo: {
    bankCardUrl: string;
    bankBranchDictName: string;
    bankDictName: string;
    bankCityDictName: string;
    bankCountryDictName: string;
    bankProvinceDictName: string;
    bankAccountName: string;
    bankAccountNumber: number;
  };
  educationInfo: {
    diplomaUrl: string;
    degreeUrl: string;
    studentCardUrl: string;
    degree: any[];
    employeeType: string;
  };
  workInfo: {
    firstJobDate: any;
    hasLaborRelation: boolean;
    works: string;
    outOfWorks: string;
    isFirstJob: number;
    resumeList: any[];
    jobOffMonth: string;
  };
  taxInfo: {
    firstEntryInMidYear?: string;
  };
  declarationInfo: {
    declarationFamilyList: any[];
    isRegisterOrInvestCompany: number;
    companyName: string;
    hasFamilyInCompany: number;
  };
  healthInfo: {
    memo: string;
  };
  showReceiveInfo: boolean;
  unableReasonList: any[];
}
class Preview extends React.Component<Props, State> {
  basicRef: React.RefObject<any>;

  personalRef: React.RefObject<any>;

  bankRef: React.RefObject<any>;

  educationRef: React.RefObject<any>;

  workRef: React.RefObject<any>;

  taxRef: React.RefObject<any>;

  declarationRef: React.RefObject<any>;

  healthRef: React.RefObject<any>;

  constructor(props) {
    super(props);
    this.basicRef = React.createRef();
    this.personalRef = React.createRef();
    this.bankRef = React.createRef();
    this.educationRef = React.createRef();
    this.workRef = React.createRef();
    this.taxRef = React.createRef(); // 个人纳税
    this.declarationRef = React.createRef();
    this.healthRef = React.createRef();
    this.state = {
      loading: true,
      employeeType: null,
      basicInfo: null,
      personalInfo: null,
      bankInfo: null,
      educationInfo: null,
      workInfo: null,
      taxInfo: null,
      declarationInfo: null,
      healthInfo: null,
      showReceiveInfo: false, // 是否展示收件人相关信息
      unableReasonList: [],
    };
  }

  async componentDidMount() {
    const { hasShowAll } = this.props;
    const { employeeType, userName } = await doAction(Url.homeDetail, {}, null);
    const personalInfo = await doAction(Url.getPersonalInfo, {}, null); // 获取个人信息
    const educationInfo = await doAction(Url.getEducationInfoV2, {}, null); // 教育信息
    const unableReasonList = await doAction(Url.getUnableReason, {}).then((res) => res?.pageList || []);
    const workInfo = await doAction(Url.getWorksInfo, {}, null); // 工作经历
    const declarationInfo = await doAction(Url.getDeclarationInfo, {}, null); // 利益申报
    let taxInfo = {};
    const status = window.checkTypeValue === 'entry';
    if (status) {
      taxInfo = await doAction(Url.getTaxInfo, {}, null); // 个税背调情景下不调用
      // 获取远程入职和S2仓信息
      const { isRemoteEntry, warehouseAddress } = (await doAction(Url.getEntryTypeAndComputer, {}, null)) || {};
      const isNeedReceiver = this.judgeNeedReceiver(isRemoteEntry, personalInfo?.computerType, warehouseAddress);
      this.setState({
        showReceiveInfo: isNeedReceiver,
      });
    }
    let basicInfo = null;
    let bankInfo = null;
    let healthInfo = null;
    if (hasShowAll) {
      basicInfo = await doAction(Url.getBasicInfo, {}, null); // 获取基本信息
      bankInfo = await doAction(Url.getBankInfo, {}, null); // 银行信息
      healthInfo = await doAction(Url.getHealthInfo, {}, null); // 健康信息
    }

    customReport(`进入 cli3 houxuanren preview ${userName || ''} ${process.env.BLOCK_ENV}`);

    this.setState({
      basicInfo,
      employeeType,
      personalInfo,
      bankInfo,
      educationInfo,
      unableReasonList,
      workInfo,
      declarationInfo,
      healthInfo,
      loading: false,
      taxInfo,
    });
  }

  // v4.2.11 判断是否展示收件人信息
  judgeNeedReceiver = (isBoardingOnline, computerVal, s2) => {
    // 当候选人满足 入职地点=“线上远程办理” ，且 选择电脑 不包含 “补贴笔记本” / “自带电脑” / “台式电脑”
    if (
      isBoardingOnline &&
      !computerVal.includes('补贴笔记本') &&
      !computerVal.includes('“自带电脑”') &&
      !computerVal?.includes('台式电脑')
    ) {
      return true;
    }
    // 当候选人满足 入职地点=“线上远程办理”，且 选择电脑包含“补贴笔记本”5个字 且S-2仓地址返回为“无”
    if (isBoardingOnline && computerVal.includes('补贴笔记本') && !s2) {
      return true;
    }
    return false;
  };

  handleDownload = (fileId, fileUrl) => {
    window.open(fileUrl);
  };

  renderTip = () => {
    return (
      <div className="preview__tip">
        <div className="basic__content">
          <div className="basic__title">照片将用于工卡制作，务必按要求提交</div>
          <ul>
            {tipList.map((v, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={i}>{v}</li>
            ))}
          </ul>
        </div>
        <img className="preview__tip-photo" src={defaultPhoto} alt="示例图片" />
      </div>
    );
  };

  renderLastJob = () => {
    const { workInfo = {} as any } = this.state;
    const {
      noProveReason,
      company,
      position,
      noProveReasonIndex,
      rank,
      startDate,
      endDate,
      competitionAgreeStartDate,
      competitionAgreeEndDate,
      witnessName,
      witnessPhone,
      witnessPosition,
      hasDismissLaborRelation,
      hasCompetitionAgreement,
      hrWitnessName,
      hrWitnessPosition,
      hrWitnessPhone,
      managerWitnessName,
      managerWitnessPosition,
      managerWitnessPhone,
      leaveReasonValue,
      leaveReasonOther,
      hasSeparationProve,
      hasProveBeforeDatatime,
      separationProveUrl,
      companyAreaName,
      hasBreakRules,
    } = workInfo;
    const notNeedCheck = window.checkTypeIndex === 0;
    let tip = '';
    if (hasSeparationProve === 'Y') {
      tip = '已取得离职证明';
    }
    if (hasProveBeforeDatatime === 'Y' && hasSeparationProve === 'N') {
      tip = '暂未拿到, 入职当天可提供';
    }
    if (hasProveBeforeDatatime === 'N' && hasSeparationProve === 'N') {
      tip = '入职当天仍无法提供离职证明';
    }
    let reason = '';
    let other = '';
    if (noProveReasonIndex === 4) {
      reason = '其他';
      other = noProveReason;
    }
    if (!isEmpty(noProveReasonIndex) && noProveReasonIndex !== 4) {
      reason = noProveReason;
    }
    return (
      <Form labelWidth="260px" mode={mode}>
        <Form.Item labelWidth={0}>
          <span className="base-form__title">最近工作经历</span>
        </Form.Item>
        <Form.Item labelWidth={0}>
          <span className="base-form__subtitle">工作信息</span>
        </Form.Item>
        <Form.Item formItemKey="hasSeparationProve" span={24} label="离职证明：">
          <span>{tip}</span>
        </Form.Item>
        <Form.Item
          formItemKey="separationProveUrl"
          span={24}
          labelWidth={0}
          style={{
            paddingLeft: '120px',
          }}
        >
          {separationProveUrl && <img className="preview__img" src={separationProveUrl} alt="" />}
        </Form.Item>
        <Form.Item formItemKey="noProveReason" span={11} label="详细原因：" hide={Boolean(isEmpty(reason))}>
          <span>{reason}</span>
        </Form.Item>
        <Form.Item formItemKey="otherReason" span={11} offset={1} label="补充说明：" hide={Boolean(isEmpty(other))}>
          <span>{other}</span>
        </Form.Item>
        <Form.Item formItemKey="company" span={11} label="公司名称：">
          <span>{company}</span>
        </Form.Item>

        <Form.Item formItemLabel="companyAreaName" offset={1} span={11} label="工作国家/地区：">
          <span>{companyAreaName}</span>
        </Form.Item>

        <Form.Item formItemKey="position" span={11} label="职位：">
          <span>{position}</span>
        </Form.Item>
        <Form.Item formItemKey="rank" span={11} offset={1} label="职级：">
          <span>{rank}</span>
        </Form.Item>

        <Form.Item formItemKey="startDate" span={11} label="工作起止时间：">
          <span className="base-form__flex">
            {startDate && `${datejs(startDate).format('YYYY-MM')} - ${datejs(endDate).format('YYYY-MM')}`}
          </span>
        </Form.Item>
        <Form.Item formItemKey="hasBreakRules" span={11} offset={1} label="有无违纪记录：">
          <span>{hasBreakRules}</span>
        </Form.Item>
        <Form.Item formItemKey="leaveReason" span={11} label="离职原因：">
          <span>{leaveReasonValue}</span>
        </Form.Item>
        <Form.Item formItemKey="leaveReasonOther" span={11} offset={1} label="原因说明：">
          <span>{leaveReasonOther}</span>
        </Form.Item>
        <Form.Item formItemKey="hasDismissLaborRelation" span={11} label="入职时是否与原单位解除劳动关系？">
          {!isEmpty(hasDismissLaborRelation) && <span>{hasDismissLaborRelation === 1 ? '是' : '否'}</span>}
        </Form.Item>
        <Form.Item
          formItemKey="hasCompetitionAgreement"
          span={11}
          offset={1}
          label="入职时是否与原单位存在竞业禁止协议？"
        >
          {!isEmpty(hasCompetitionAgreement) && <span>{hasCompetitionAgreement === 1 ? '是' : '否'}</span>}
        </Form.Item>
        <Form.Item
          formItemKey="competitionAgreeStartDate"
          span={11}
          label="竞业开始时间："
          hide={Boolean(isEmpty(hasCompetitionAgreement)) || hasCompetitionAgreement === 0}
        >
          <span>{competitionAgreeStartDate && datejs(competitionAgreeStartDate).format('YYYY-MM')}</span>
        </Form.Item>
        <Form.Item
          formItemKey="competitionAgreeEndDate"
          span={11}
          offset={1}
          label="竞业结束时间："
          hide={Boolean(isEmpty(hasCompetitionAgreement)) || hasCompetitionAgreement === 0}
        >
          <span>{competitionAgreeEndDate && datejs(competitionAgreeEndDate).format('YYYY-MM')}</span>
        </Form.Item>
        <Form.Item labelWidth={0} hide={Boolean(isEmpty(hrWitnessName))}>
          <span className="base-form__subtitle">
            人事部证明人
            <span className="base-form__desc">（请务必提供人事部在职在岗同事）</span>
          </span>
        </Form.Item>
        <Form.Item formItemKey="witnessName" span={11} label="姓名：" hide={Boolean(isEmpty(hrWitnessName))}>
          <span>{hrWitnessName}</span>
        </Form.Item>
        <Form.Item
          formItemKey="witnessPhone"
          span={11}
          offset={1}
          label="手机号："
          hide={Boolean(isEmpty(hrWitnessName))}
        >
          <span>{hrWitnessPhone}</span>
        </Form.Item>
        <Form.Item formItemKey="witnessPosition" span={11} label="职位：" hide={Boolean(isEmpty(hrWitnessName))}>
          <span>{hrWitnessPosition}</span>
        </Form.Item>

        <Form.Item labelWidth={0} hide={Boolean(isEmpty(managerWitnessName))}>
          <span className="base-form__subtitle">
            直接主管证明人
            <span className="base-form__desc"> (请务必提供您在该公司的最后一任上级) </span>
          </span>
        </Form.Item>
        <Form.Item formItemKey="witnessName" span={11} label="姓名：" hide={Boolean(isEmpty(managerWitnessName))}>
          <span>{managerWitnessName}</span>
        </Form.Item>
        <Form.Item
          formItemKey="witnessPhone"
          span={11}
          offset={1}
          label="手机号："
          hide={Boolean(isEmpty(managerWitnessName))}
        >
          <span>{managerWitnessPhone}</span>
        </Form.Item>
        <Form.Item formItemKey="witnessPosition" span={11} label="职位：" hide={Boolean(isEmpty(managerWitnessName))}>
          <span>{managerWitnessPosition}</span>
        </Form.Item>
        <Form.Item span={7} hide={Boolean(isEmpty(managerWitnessName))} />
        <Form.Item labelWidth={0}>
          <span className="base-form__subtitle">同事证明人</span>
        </Form.Item>
        <Form.Item formItemKey="witnessName" span={11} label="姓名：">
          <span>{witnessName}</span>
        </Form.Item>
        <Form.Item formItemKey="witnessPhone" span={11} offset={1} label="手机号：">
          <span>{witnessPhone}</span>
        </Form.Item>
        <Form.Item formItemKey="witnessPosition" span={11} label="职位：">
          <span>{witnessPosition}</span>
        </Form.Item>
        <Form.Item span={7} />
      </Form>
    );
  };

  renderWorks = (works) => {
    return works.map((item) => {
      const {
        company,
        companyAreaName,
        position,
        jobLevel,
        startDate,
        endDate,
        hasBreakRules,
        leaveReasonValue,
        hrWitnessName,
        hrWitnessPhone,
        hrWitnessPosition,
        managerWitnessName,
        managerWitnessPhone,
        managerWitnessPosition,
        witnessName,
        witnessPhone,
        witnessPosition,
        leaveReasonOther,
      } = item;
      const notNeedCheck = window.checkTypeIndex === 0;
      return (
        <Form labelWidth="110px">
          <Form.Item labelWidth={0} span={20}>
            <span className="base-form__subtitle">工作经历</span>
          </Form.Item>
          <Form.Item formItemKey="company" span={11} label="公司名称：">
            <span>{company}</span>
          </Form.Item>

          <Form.Item formItemLabel="companyAreaName" offset={1} span={11} label="工作国家/地区：">
            <span>{companyAreaName}</span>
          </Form.Item>

          <Form.Item formItemKey="position" span={11} label="职位：">
            <span>{position}</span>
          </Form.Item>
          <Form.Item formItemKey="jobLevel" span={11} offset={1} label="职级：">
            <span>{jobLevel}</span>
          </Form.Item>

          <Form.Item formItemKey="startDate" span={11} label="工作起止时间：">
            <span className="base-form__flex">
              {startDate && `${datejs(startDate).format('YYYY-MM')} - ${datejs(endDate).format('YYYY-MM')}`}
            </span>
          </Form.Item>

          <Form.Item formItemKey="hasBreakRules" span={11} offset={1} label="有无违纪记录：">
            <span>{hasBreakRules}</span>
          </Form.Item>

          <Form.Item formItemLabel="leaveReasonValue" span={11} label="离职原因：">
            <span>{leaveReasonValue}</span>
          </Form.Item>
          <Form.Item formItemKey="leaveReason" span={11} offset={1} label="离职说明：">
            <span>{leaveReasonOther}</span>
          </Form.Item>
          <Form.Item labelWidth={0} hide={Boolean(isEmpty(hrWitnessName))}>
            <span className="base-form__subtitle">
              人事部证明人
              <span className="base-form__desc">（请务必提供人事部在职在岗同事）</span>
            </span>
          </Form.Item>
          <Form.Item formItemKey="hrWitnessName" span={11} label="姓名：" hide={Boolean(isEmpty(hrWitnessName))}>
            <span>{hrWitnessName}</span>
          </Form.Item>
          <Form.Item
            formItemKey="hrWitnessPhone"
            span={11}
            label="手机号："
            offset={1}
            hide={Boolean(isEmpty(hrWitnessName))}
          >
            <span>{hrWitnessPhone}</span>
          </Form.Item>
          <Form.Item formItemKey="hrWitnessPosition" span={11} label="职位：" hide={Boolean(isEmpty(hrWitnessName))}>
            <span>{hrWitnessPosition}</span>
          </Form.Item>

          <Form.Item labelWidth={0} hide={Boolean(isEmpty(managerWitnessName))}>
            <span className="base-form__subtitle">
              直接主管证明人
              <span className="base-form__desc">（请务必提供您在该公司的最后一任上级）</span>
            </span>
          </Form.Item>
          <Form.Item
            formItemKey="managerWitnessName"
            span={11}
            label="姓名："
            hide={Boolean(isEmpty(managerWitnessName))}
          >
            <span>{managerWitnessName}</span>
          </Form.Item>
          <Form.Item
            formItemKey="managerWitnessPhone"
            span={11}
            offset={1}
            label="手机号："
            hide={Boolean(isEmpty(managerWitnessName))}
          >
            <span>{managerWitnessPhone}</span>
          </Form.Item>
          <Form.Item
            formItemKey="managerWitnessPosition"
            span={11}
            label="职位："
            hide={Boolean(isEmpty(managerWitnessName))}
          >
            <span>{managerWitnessPosition}</span>
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__subtitle">同事证明人</span>
          </Form.Item>
          <Form.Item formItemKey="witnessName" span={11} label="姓名：">
            <span>{witnessName}</span>
          </Form.Item>
          <Form.Item formItemKey="witnessPhone" span={11} label="手机号：" offset={1}>
            <span>{witnessPhone}</span>
          </Form.Item>
          <Form.Item formItemKey="witnessPosition" span={11} label="职位：">
            <span>{witnessPosition}</span>
          </Form.Item>
          <Form.Item span={11} />
        </Form>
      );
    });
  };

  renderOutWorks = (outOfWorks) => {
    return outOfWorks.map((item, index) => {
      const { reasonParent, reasonChid, startDate, endDate, reason } = item;
      return (
        <Form labelWidth="120px" mode={mode}>
          <Form.Item labelWidth={0}>
            <span className="base-form__subtitle">歇业描述</span>
          </Form.Item>

          <Form.Item formItemLabel="reasonParent" span={11} label="歇业类型：" labelWidth={0}>
            <span className="base-form__flex">{reason}</span>
          </Form.Item>

          <Form.Item formItemKey="startDate" span={11} offset={1} label="起止时间：" labelWidth={0}>
            <span className="base-form__flex">
              {startDate && `${datejs(startDate).format('YYYY-MM')} - ${datejs(endDate).format('YYYY-MM')}`}
            </span>
          </Form.Item>
        </Form>
      );
    });
  };

  renderBasic = () => {
    const { basicInfo } = this.state;
    if (!basicInfo) return null;
    const {
      photoUrl,
      pinYinXingName,
      pinYinMingName,
      chXing,
      chMing,
      englishName,
      positionName,
      entryDateStr,
      deptName,
    } = basicInfo;
    return (
      <div className="basic">
        <Form className="basic__form" ref={this.basicRef} mode={mode} labelWidth="100px">
          <Form.Item formItemKey="photoUrl" label="白底证件照：">
            <div className="basic__wrapper preview__flex">
              {photoUrl && <img className="preview__photo" src={photoUrl} alt="" />}
              {this.renderTip()}
            </div>
          </Form.Item>
          <Form.Item formItemKey="chXing" label="姓：">
            <span>{chXing}</span>
          </Form.Item>
          <Form.Item formItemKey="chMing" label="名：">
            <span>{chMing}</span>
          </Form.Item>
          <Form.Item formItemLabel="pinYinXingName" label="拼音姓：">
            <span>{pinYinXingName}</span>
          </Form.Item>
          <Form.Item formItemLabel="pinYinMingName" label="拼音名：">
            <span>{pinYinMingName}</span>
          </Form.Item>
          <Form.Item hide formItemKey="englishName" label="英文名：">
            <span>{englishName}</span>
          </Form.Item>
          <Form.Item formItemKey="positionName" label="职位：">
            <span>{positionName}</span>
          </Form.Item>
          <Form.Item formItemKey="entryDateStr" label="入职日期：">
            <span>{entryDateStr}</span>
          </Form.Item>
          <Form.Item formItemKey="deptName" label="部门：">
            <span>{deptName}</span>
          </Form.Item>
        </Form>
      </div>
    );
  };

  renderPerson = () => {
    const { personalInfo, showReceiveInfo } = this.state;
    if (!personalInfo) return null;
    const {
      socialSecurityUrl,
      relationDictName,
      area,
      handicappedUrl,
      maritalStatusDictName,
      residentialCityDictName,
      residentialProvinceDictName,
      residentialNationDictName,
      registerCityDictName,
      registerProvinceDictName,
      registerNationDictName,
      politicalStatusDictName,
      registerTypeDictName,
      hometownCityDictName,
      hometownProvinceDictName,
      nationDictName,
      nationalityDictName,
      certTypeDictName,
      indentityCardFrontUrl,
      indentityCardBackUrl,
      birthday,
      certNumber,
      gender,
      registerAddress,
      residentialDetailAddress,
      hasChildren,
      isHandicapped,
      handicappedNumber,
      phone,
      email,
      wxNumber,
      qqNumber,
      relationName,
      relationPhone,
      hasSocialSecurity,
      computerType,
      recipientName,
      recipientPhone,
      recipientProvinceDictName,
      recipientCityDictName,
      recipientDistrictDictName,
      recipientDetailAddress,
    } = personalInfo;
    return (
      <div className="person">
        <Form className="person__form" ref={this.personalRef} labelWidth="120px">
          <Form.Item formItemLabel="certTypeDictName" span={11} label="证件类型：">
            <span>{certTypeDictName}</span>
          </Form.Item>
          <Form.Item span={11} />
          <Form.Item formItemKey="indentityCardFrontUrl" span={7}>
            {indentityCardFrontUrl && <img className="preview__img" src={indentityCardFrontUrl} alt="" />}
          </Form.Item>
          <Form.Item formItemKey="indentityCardBackUrl" span={6} offset={0.2} labelWidth={0}>
            {indentityCardBackUrl && <img className="preview__img" src={indentityCardBackUrl} alt="" />}
          </Form.Item>
          <Form.Item span={11} />
          <Form.Item formItemKey="certNumber" span={11} label="证件号码：">
            <span>{certNumber}</span>
          </Form.Item>
          <Form.Item formItemKey="birthday" span={11} offset={2} label="生日：">
            <span>{birthday && datejs(birthday).format('YYYY-MM-DD')}</span>
          </Form.Item>

          <Form.Item formItemKey="gender" span={11} label="性别：">
            <span>{gender === 'M' ? '男' : '女'}</span>
          </Form.Item>
          <Form.Item formItemLabel="nationalityDictName" span={11} offset={2} label="国籍：">
            <span>{nationalityDictName}</span>
          </Form.Item>

          <Form.Item formItemLabel="nationDictName" span={11} label="民族：">
            <span>{nationDictName}</span>
          </Form.Item>
          <Form.Item formItemLabel="hometownProvinceDictName" span={11} offset={2} label="籍贯：">
            {hometownProvinceDictName && <span>{`${hometownProvinceDictName} - ${hometownCityDictName}`}</span>}
          </Form.Item>

          <Form.Item formItemLabel="registerTypeDictName" span={11} label="户口类型：">
            <span>{registerTypeDictName}</span>
          </Form.Item>
          <Form.Item formItemLabel="politicalStatusDictName" span={11} offset={2} label="政治面貌：">
            <span>{politicalStatusDictName}</span>
          </Form.Item>

          <Form.Item formItemLabel="registerNationDictName" span={11} label="户口所在地：">
            {registerProvinceDictName && (
              <span>{`${registerNationDictName} - ${registerProvinceDictName} - ${registerCityDictName}`}</span>
            )}
          </Form.Item>

          <Form.Item formItemLabel="residentialNationDictName" span={11} offset={2} label="现居住地：">
            <span>{`${residentialNationDictName} - ${residentialProvinceDictName} - ${residentialCityDictName}`}</span>
          </Form.Item>

          <Form.Item formItemKey="registerAddress" span={11} label="&nbsp;">
            <span>{registerAddress}</span>
          </Form.Item>
          <Form.Item formItemKey="residentialDetailAddress" span={11} offset={2} label="&nbsp;">
            <span>{residentialDetailAddress}</span>
          </Form.Item>

          <Form.Item formItemLabel="maritalStatusDictName" span={11} label="婚姻状况：">
            <span>{maritalStatusDictName}</span>
          </Form.Item>
          <Form.Item formItemKey="hasChildren" span={11} offset={2} label="子女状况：">
            <span>{hasChildren === 1 ? '有' : '无'}</span>
          </Form.Item>

          <Form.Item formItemKey="isHandicapped" span={11} label="残疾/残障人士：">
            <span>{isHandicapped ? '是' : '否'}</span>
          </Form.Item>
          <Form.Item span={10} />
          <Form.Item formItemKey="handicappedNumber" span={10} labelWidth={0} hide={!isHandicapped}>
            <span>{handicappedNumber}</span>
          </Form.Item>
          <Form.Item span={10} />
          <Form.Item formItemKey="handicappedUrl" span={10} labelWidth={0} hide={!isHandicapped}>
            {handicappedUrl && <img className="preview__img" src={handicappedUrl} alt="" />}
          </Form.Item>

          <Form.Item>
            <span className="base-form__dividing" />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">联系方式</span>
          </Form.Item>
          <Form.Item formItemKey="area" span={11} label="移动电话：">
            <span>{`${area} - ${phone}`}</span>
          </Form.Item>
          <Form.Item formItemKey="email" span={11} offset={2} label="个人邮箱：">
            <span>{email}</span>
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">紧急联系人</span>
          </Form.Item>
          <Form.Item formItemKey="relationName" span={11} label="姓名：">
            <span>{relationName}</span>
          </Form.Item>
          <Form.Item formItemKey="relationDictName" span={11} offset={2} label="与本人关系：">
            <span>{relationDictName}</span>
          </Form.Item>
          <Form.Item formItemKey="area" span={11} label="紧急联系电话：">
            {relationPhone && <span>{`${area} - ${relationPhone} `}</span>}
          </Form.Item>
          <Form.Item span={6} />

          <Form.Item labelWidth={0}>
            <span className="base-form__title">社保信息</span>
          </Form.Item>
          <Form.Item formItemKey="hasSocialSecurity" span={20} label="是否在即将入职的工作城市办理过社保：">
            <span>{hasSocialSecurity === 1 ? '是' : '否'}</span>
          </Form.Item>
          <Form.Item formItemKey="socialSecurityUrl" hide={hasSocialSecurity === 1}>
            {socialSecurityUrl && <img className="preview__img" src={socialSecurityUrl} alt="" />}
          </Form.Item>
          {computerType && (
            <>
              <Form.Item labelWidth={0}>
                <span className="base-form__title">选择办公电脑</span>
              </Form.Item>
              <Form.Item formItemKey="computerType" span={11} label="选择电脑：">
                <span>{computerType}</span>
              </Form.Item>
            </>
          )}
          {showReceiveInfo && (
            <>
              <Form.Item labelWidth={0}>
                <span className="base-form__title">填写收件信息</span>
              </Form.Item>

              <Form.Item formItemKey="recipientName" span={6} label="收件人：">
                <span>{recipientName}</span>
              </Form.Item>
              <Form.Item formItemKey="recipientPhone" span={6} label="移动电话：">
                <span>{recipientPhone}</span>
              </Form.Item>
              <Form.Item formItemKey="recipientAddr" span={6} label="收件地址：">
                <span>
                  {recipientProvinceDictName} {recipientCityDictName} {recipientDistrictDictName}
                </span>
              </Form.Item>
              <Form.Item formItemKey="recipientDetailAddress" span={6}>
                <span>{recipientDetailAddress}</span>
              </Form.Item>
            </>
          )}
        </Form>
      </div>
    );
  };

  renderBackPerson = () => {
    const { personalInfo } = this.state;
    if (!personalInfo) return null;
    const {
      relationDictName,
      area,
      nationDictName,
      nationalityDictName,
      certTypeDictName,
      indentityCardFrontUrl,
      indentityCardBackUrl,
      birthday,
      certNumber,
      gender,
      phone,
      email,
      relationName,
      relationPhone,
    } = personalInfo;
    return (
      <div className="person">
        <Form className="person__form" ref={this.personalRef} labelWidth="120px">
          <Form.Item formItemLabel="certTypeDictName" span={11}>
            <span>{certTypeDictName}</span>
          </Form.Item>
          <Form.Item span={11} />
          <Form.Item formItemKey="indentityCardFrontUrl" span={7}>
            {indentityCardFrontUrl && <img className="preview__img" src={indentityCardFrontUrl} alt="" />}
          </Form.Item>
          <Form.Item formItemKey="indentityCardBackUrl" span={6} offset={0.2} labelWidth={0}>
            {indentityCardBackUrl && <img className="preview__img" src={indentityCardBackUrl} alt="" />}
          </Form.Item>
          <Form.Item span={11} />
          <Form.Item formItemKey="certNumber" span={11} label="证件号码：">
            <span>{certNumber}</span>
          </Form.Item>
          <Form.Item formItemKey="birthday" span={11} offset={2} label="生日：">
            <span>{birthday && datejs(birthday).format('YYYY-MM-DD')}</span>
          </Form.Item>

          <Form.Item formItemKey="gender" span={11} label="性别：">
            <span>{gender === 'M' ? '男' : '女'}</span>
          </Form.Item>
          <Form.Item formItemLabel="nationalityDictName" span={11} offset={2} label="国籍：">
            <span>{nationalityDictName}</span>
          </Form.Item>

          <Form.Item>
            <span className="base-form__dividing" />
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">联系方式</span>
          </Form.Item>
          <Form.Item formItemKey="area" span={11} label="移动电话：">
            {phone && <span>{`${area} - ${phone}`}</span>}
          </Form.Item>
          <Form.Item formItemKey="email" span={11} offset={2} label="个人邮箱：">
            <span>{email}</span>
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">紧急联系人</span>
          </Form.Item>
          <Form.Item formItemKey="relationName" span={11} label="姓名：">
            <span>{relationName}</span>
          </Form.Item>
          <Form.Item formItemKey="relationDictName" span={11} offset={2} label="与本人关系：">
            <span>{relationDictName}</span>
          </Form.Item>
          <Form.Item formItemKey="area" span={11} label="紧急联系电话：">
            {relationPhone && <span>{`${area} - ${relationPhone} `}</span>}
          </Form.Item>
          <Form.Item span={6} />
        </Form>
      </div>
    );
  };

  // <div className="bank__announcement">
  // <Announcement title="重要提示：不要使用二类账户银行卡，否则将影响您的正常发薪。准确提供本人开户的银行储蓄卡相关信息，因信息填写有误造成的损失由员工本人承担。" showIcon type="warning" />
  //       </div>
  renderBank = () => {
    const { bankInfo } = this.state;
    if (!bankInfo) return null;
    const {
      bankCardUrl,
      bankBranchDictName,
      bankDictName,
      bankCityDictName,
      bankCountryDictName,
      bankProvinceDictName,
      bankAccountName,
      bankAccountNumber,
    } = bankInfo;
    return (
      <div className="bank">
        <Form className="bank__form" ref={this.bankRef} labelWidth="100px">
          <Form.Item formItemLabel="bankCountryDictName" span={12} label="银行开户地：">
            <span>{`${bankCountryDictName} - ${bankProvinceDictName} - ${bankCityDictName}`}</span>
          </Form.Item>
          <Form.Item span={10} label="&nbsp;" />
          <Form.Item formItemKey="bankDictName" label="银行开户行：">
            <span>{bankDictName}</span>
          </Form.Item>
          <Form.Item formItemKey="bankBranchDictName" label="银行支行：">
            <span>{bankBranchDictName}</span>
          </Form.Item>
          <Form.Item formItemKey="bankAccountName" label="银行账户名：">
            <span>{bankAccountName}</span>
          </Form.Item>
          <Form.Item formItemKey="bankAccountNumber" label="银行卡号：">
            <span>{bankAccountNumber}</span>
          </Form.Item>
          <Form.Item formItemKey="bankCardUrl" label="银行卡照片：" hide={!bankCardUrl}>
            {bankCardUrl && <img className="preview__img" src={bankCardUrl} alt="" />}
          </Form.Item>
        </Form>
      </div>
    );
  };

  renderEducation = () => {
    const { educationInfo, unableReasonList } = this.state;
    if (!educationInfo) return null;
    const adapterData = handleAdapterData(educationInfo);
    const { degree, supplementAttachList, isIntern } = adapterData;

    return (
      <div className="education">
        {degree.map((item) => {
          const {
            educationTypeDictName,
            educationTypeDictIndex,
            isTopDegree,
            degreeDictName,
            diplomaDictName,
            startDate,
            endDate,
            countryDictName,
            schoolDictName,
            majorDictName,
          } = item;
          const eduType = getEduType(item, isIntern);

          return (
            // 最高xxx教育经历label会折行，需要宽一点
            <Form labelWidth="160px">
              <Form.Item formItemKey="isTopDegree" labelWidth={0}>
                <span className="base-form__title">教育经历</span>
              </Form.Item>

              <Form.Item formItemKey="startDate" span={11} label="起止时间：" required>
                <span className="base-form__flex">
                  {startDate && `${datejs(startDate).format('YYYY-MM')} - ${datejs(endDate).format('YYYY-MM')}`}
                </span>
              </Form.Item>

              <Form.Item formItemKey="countryDictName" span={11} offset={1} label="国家/地区：">
                <span>{countryDictName}</span>
              </Form.Item>

              <Form.Item formItemKey="schoolDictName" span={11} label="学校：">
                <span>{schoolDictName}</span>
              </Form.Item>
              <Form.Item formItemKey="majorDictName" span={11} offset={1} label="专业：">
                <span>{majorDictName}</span>
              </Form.Item>

              <Form.Item formItemKey="diplomaDictName" span={11} label="学历：">
                <span>{diplomaDictName}</span>
              </Form.Item>
              <Form.Item formItemKey="degreeDictName" span={11} offset={1} label="学位：">
                <span>{degreeDictName}</span>
              </Form.Item>

              <Form.Item formItemKey="educationTypeDictName" span={11} label="教育性质：">
                <span>{educationTypeDictName}</span>
              </Form.Item>

              <Form.Item
                formItemKey="educationTypeDictName"
                span={11}
                offset={1}
                label={`最高${educationTypeDictIndex === '71' ? '全日制' : '非全日制'}教育经历：`}
              >
                <span>{isTopDegree ? '是' : '否'}</span>
              </Form.Item>

              {/* 预览待验证，预览被大改动了，需要重新检查 */}
              <Form.Item className="certificate-upload-group" labelWidth={0}>
                <CertificateUploadGroup
                  // 根据不同的eduType，会有不同的上传附件模块，但总的不会超过3个
                  eduType={eduType}
                  // currentData用于初次回显和后续改变其他文件，以及内部的一些联动判断
                  data={item}
                  unableReasonList={unableReasonList}
                  mode="view"
                  labelWidth="160px"
                  rightOffset={1}
                />
              </Form.Item>
            </Form>
          );
        })}

        <Supplementary supplementAttachList={supplementAttachList} mode={mode} />
      </div>
    );
  };

  renderWork = () => {
    const { workInfo } = this.state;
    if (!workInfo) return null;
    const { firstJobDate, hasLaborRelation, works, outOfWorks, isFirstJob, resumeList, jobOffMonth } = workInfo;
    const hide = isFirstJob === 1;
    return (
      <div className="workInfoPreview">
        <Form labelWidth="15em" mode={mode}>
          <Form.Item labelWidth={0}>
            <span className="base-form__title">首次工作经历</span>
          </Form.Item>
          <Form.Item formItemKey="isFirstJob" span={20} label="本次入职是否为第一份正式工作：">
            {!isEmpty(isFirstJob) && <span>{isFirstJob === 1 ? '是' : '否'}</span>}
          </Form.Item>
          <Form.Item formItemKey="firstJobDate" span={10} label="第一份正式工作开始日期：" hide={hide}>
            <span>{firstJobDate && datejs(firstJobDate).format('YYYY-MM-DD')}</span>
          </Form.Item>
        </Form>
        {!hide && this.renderLastJob()}
        {!hide && this.renderWorks(works)}
        {outOfWorks && outOfWorks.length > 0 && (
          <div className="base-form__title">
            歇业经历
            <span className="base-form__desc">
              （确保最近5年工作经历之间没有间隔，且工作经历不能有超过6个月的间隔，若有歇业经历请补充完整）
            </span>
          </div>
        )}
        {this.renderOutWorks(outOfWorks)}
        {resumeList && resumeList.length > 0 && <span className="base-form__subtitle">简历</span>}
        {resumeList?.map((item) => {
          const { fileName, fileId, fileUrl } = item || {};
          return (
            <div className="preview__file">
              <span>
                <Icon type="file-o" />
                {fileName}
              </span>
              <span>
                <Icon type="download-o" onClick={() => this.handleDownload('fileId', fileUrl)} />
              </span>
            </div>
          );
        })}
      </div>
    );
  };

  renderBackWork = () => {
    const { workInfo } = this.state;
    if (!workInfo) return null;
    const { works, outOfWorks, resumeList } = workInfo;
    // const { fileName, fileId, fileUrl } = resumeList || [];
    return (
      <div className="workInfo">
        {this.renderWorks(works)}
        {outOfWorks && outOfWorks.length > 0 && (
          <div className="base-form__title">
            歇业经历
            <span className="base-form__desc">
              （确保最近5年工作经历之间没有间隔，且工作经历不能有超过6个月的间隔，若有歇业经历请补充完整）
            </span>
          </div>
        )}
        {this.renderOutWorks(outOfWorks)}
        {resumeList &&
          resumeList.map((item) => {
            const { fileName, fileId, fileUrl } = item || {};
            return (
              <div className="evaluation__file">
                <span>
                  <Icon type="file-o" />
                  {fileName}
                </span>
                <span>
                  <Icon type="download-o" onClick={() => this.handleDownload('fileId', fileUrl)} />
                </span>
              </div>
            );
          })}
      </div>
    );
  };

  renderTax = () => {
    const { taxInfo } = this.state;
    if (!taxInfo) return null;
    return (
      <div className="tax">
        <Form className="tax tax__form" ref={this.taxRef} labelWidth="100px">
          <Form.Item formItemKey="firstEntryInMidYear" span={12} label="年内首次入职：">
            <span>{taxInfo.firstEntryInMidYear ? '是' : '否'}</span>
          </Form.Item>
        </Form>
      </div>
    );
  };

  renderDeclaration = () => {
    const { declarationInfo } = this.state;
    if (!declarationInfo) return null;
    const { declarationFamilyList, isRegisterOrInvestCompany, companyName, hasFamilyInCompany } = declarationInfo;
    return (
      <div className="declaration">
        <Form className="declaration__form" mode={mode} labelWidth="170px">
          <Form.Item labelWidth={0}>
            <span className="base-form__title">商业冲突</span>
          </Form.Item>
          <Form.Item
            formItemKey="isRegisterOrInvestCompany"
            label={
              <span>
                是否在外部公司挂职
                <Tooltip message="包括在外部公司挂职法人、董事、监事、高级管理人员、顾问等身份">
                  <Icon type="warning-circle-o" />
                </Tooltip>
                ：
              </span>
            }
          >
            {!isEmpty(isRegisterOrInvestCompany) && <span>{isRegisterOrInvestCompany === 1 ? '是' : '否'}</span>}
          </Form.Item>

          <Form.Item formItemKey="companyName" label="公司名称：" hide={isRegisterOrInvestCompany !== 1}>
            <span>{companyName}</span>
          </Form.Item>

          <Form.Item labelWidth={0}>
            <span className="base-form__title">亲属申报</span>
          </Form.Item>
          <Form.Item formItemKey="hasFamilyInCompany" label="是否有亲属就职于本公司：">
            {!isEmpty(hasFamilyInCompany) && <span>{hasFamilyInCompany === 1 ? '是' : '否'}</span>}
          </Form.Item>
        </Form>
        {hasFamilyInCompany === 1 &&
          declarationFamilyList &&
          declarationFamilyList.length > 0 &&
          declarationFamilyList.map((item, index) => {
            const { name, relationDictName, remarks, phone } = item;
            return (
              <Form mode={mode} labelWidth="120px">
                <Form.Item formItemKey="isTopDegree" labelWidth="40px">
                  <span className="base-form__subtitle">亲属{index + 1}</span>
                </Form.Item>

                <Form.Item formItemKey="name" label="亲属姓名：">
                  <span>{name}</span>
                </Form.Item>

                <Form.Item formItemLabel="relationDictName" label="亲属关系：">
                  <span>{relationDictName}</span>
                </Form.Item>

                <Form.Item formItemLabel="phone" label="亲属联系电话：">
                  <span>{phone}</span>
                </Form.Item>

                <Form.Item formItemKey="remarks" label="补充说明：">
                  <span>{remarks}</span>
                </Form.Item>
              </Form>
            );
          })}
      </div>
    );
  };

  renderHealth = () => {
    const { healthInfo } = this.state;
    if (!healthInfo) return null;
    return (
      <div className="health">
        <Form className="declaration__form" labelWidth="200px">
          <Form.Item formItemKey="isRegisterOrInvestCompany" label="白血病,血友病,再生障碍性贫血等：">
            <span>{healthInfo[0].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[0].memo && <div>{healthInfo[0].memo}</div>}
          </Form.Item>

          <Form.Item formItemKey="companyName" label="各种恶性肿瘤和肝硬化：">
            <span>{healthInfo[1].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[1].memo && <div>{healthInfo[1].memo}</div>}
          </Form.Item>

          <Form.Item formItemKey="hasFamilyInCompany" label="癫痫：">
            <span>{healthInfo[2].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[2].memo && <div>{healthInfo[2].memo}</div>}
          </Form.Item>

          <Form.Item formItemKey="hasFamilyInCompany" label="精神类疾病：">
            <span>{healthInfo[3].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[3].memo && <div>{healthInfo[3].memo}</div>}
          </Form.Item>

          <Form.Item formItemKey="hasFamilyInCompany" label="先天性心脏病,风湿性心脏病,结核等：">
            <span>{healthInfo[4].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[4].memo && <div>{healthInfo[4].memo}</div>}
          </Form.Item>

          <Form.Item formItemKey="hasFamilyInCompany" label="红斑狼疮等：">
            <span>{healthInfo[5].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[5].memo && <div>{healthInfo[5].memo}</div>}
          </Form.Item>

          <Form.Item formItemKey="hasFamilyInCompany" label="其他：">
            <span>{healthInfo[6].hasSick === 1 ? '有' : '无'}</span>
            {healthInfo[6].memo && <div>{healthInfo[6].memo}</div>}
          </Form.Item>
        </Form>
      </div>
    );
  };

  render() {
    const { hasShowAll } = this.props;
    const { loading, employeeType, taxInfo } = this.state;
    if (loading) return null;
    return (
      <>
        {hasShowAll && (
          <div className="preview">
            <a href="#basicInfo" className="preview__title">
              基本信息
            </a>
            {this.renderBasic()}
            <a href="#personalInfo" className="preview__title">
              个人信息
            </a>
            {this.renderPerson()}
            <a href="#bankInfo" className="preview__title">
              银行信息
            </a>
            {this.renderBank()}
            <a href="#educationsInfo" className="preview__title">
              教育经历
            </a>
            {this.renderEducation()}
            <a href="#worksInfo" className="preview__title">
              工作经历
            </a>
            {this.renderWork()}
            <a href="#declaration" className="preview__title">
              利益申报
            </a>
            {this.renderDeclaration()}
            <a href="#healthInfo" className="preview__title">
              健康信息
            </a>
            {this.renderHealth()}
            {employeeType === '101' && taxInfo && taxInfo.firstEntryInMidYear !== null && (
              <div>
                <a href="#taxInfo" className="preview__title">
                  个税承诺
                </a>
                {this.renderTax()}
              </div>
            )}
          </div>
        )}
        {!hasShowAll && (
          <div className="preview">
            <a href="#personalInfo" className="preview__title">
              个人信息
            </a>
            {this.renderBackPerson()}
            <a href="#educationsInfo" className="preview__title">
              教育经历
            </a>
            {this.renderEducation()}
            <a href="#worksInfo" className="preview__title">
              工作经历
            </a>
            {this.renderWork()}
            <a href="#declaration" className="preview__title">
              利益申报
            </a>
            {this.renderDeclaration()}
          </div>
        )}
      </>
    );
  }
}

export default Preview;
